export const propertyPageFloorplans = ['$scope', '$location', function ($scope, $location) {
  var urlModal = window.location.search.indexOf('modal=specials') !== -1
  $scope.specialsModal = urlModal;
}]
